<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <f7-page class="main-test-component">
    <template #fixed>
      <TheNavbar
        :nav-title="$t('common.components')"
        :back-btn-enable="true"
        :back-callback="BackToMain"
        :style="appTheme"
      />
    </template>
    <div class="searchbar-container">
      <f7-searchbar
        search-container=".search-list"
        search-in=".item-title"
        :placeholder="$t('common.search')"
      />
    </div>

    <f7-list class="content-list margin-top searchbar-not-found">
      <f7-list-item title="No hay resultados" />
    </f7-list>
    <f7-list
      class="content-list margin-top search-list searchbar-found"
      inset
    >
      <f7-list-item
        v-for="component in components"
        :key="component.title"
        accordion-item
        :title="component.title"
      >
        <f7-accordion-content>
          <component :is="component.name" />
          <br>
        </f7-accordion-content>
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
import TheNavbar from '@/components/TheNavbar.vue';
import TestPCShowNoResults from '@/pages/TEST-COMPONENT/TestPCShowNoResults.vue';
import TestUCConfirmation from '@/pages/TEST-COMPONENT/TestUCConfirmation.vue';
import TestUCDatePicker from '@/pages/TEST-COMPONENT/TestUCDatePicker.vue';
import TestUCEmptyList from '@/pages/TEST-COMPONENT/TestUCEmptyList.vue';
import TestUCInformationWithoutSearchRecord from '@/pages/TEST-COMPONENT/TestUCInformationWithoutSearchRecord.vue';
import TestUCInputIncrement from '@/pages/TEST-COMPONENT/TestUCInputIncrement.vue';
import TestUCPreload from '@/pages/TEST-COMPONENT/TestUCPreload.vue';
import TestUCSearchEntityERP from '@/pages/TEST-COMPONENT/TestUCSearchEntityERP.vue';
import TestUCSupplementaryData from '@/pages/TEST-COMPONENT/TestUCSupplementaryData.vue';
import TestUCTimePicker from '@/pages/TEST-COMPONENT/TestUCTimePicker.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'TestComponent',
  components: {
    TheNavbar,
    TestPCShowNoResults,
    TestUCConfirmation,
    TestUCDatePicker,
    TestUCEmptyList,
    TestUCInformationWithoutSearchRecord,
    TestUCInputIncrement,
    TestUCPreload,
    TestUCSearchEntityERP,
    TestUCSupplementaryData,
    TestUCTimePicker,
  },
  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },
    components() {
      return [
        { name: 'TestPCShowNoResults', title: 'PCShowNoResults' },
        { name: 'TestUCConfirmation', title: 'UCConfirmation' },
        { name: 'TestUCDatePicker', title: 'UCDatePicker' },
        { name: 'TestUCEmptyList', title: 'UCEmptyList' },
        { name: 'TestUCInformationWithoutSearchRecord', title: 'UCInformationWithoutSearchRecord' },
        { name: 'TestUCInputIncrement', title: 'UCInputIncrement' },
        { name: 'TestUCPreload', title: 'UCPreload' },
        { name: 'TestUCSearchEntityERP', title: 'UCSearchEntityERP' },
        { name: 'TestUCSupplementaryData', title: 'UCSupplementaryData' },
        { name: 'TestUCTimePicker', title: 'UCTimePicker' },
      ];
    },
  },
  methods: {
    BackToMain() {
      f7.views.main.router.back();
    },
  },
};
</script>

<style lang="scss">
.main-test-component {
  .searchbar-container {
    margin: auto;
    max-width: 80%;
  }

  .content-list {
    margin: auto;
    max-width: 75%;
    --f7-list-item-title-text-color: var(--his-light-blue);
    --f7-list-item-title-font-size: 16px;
    --f7-list-item-title-font-weight: 600;
    --f7-list-chevron-icon-color: var(--his-oliva);

    .accordion-item {
      border-bottom: 1px solid var(--his-light-blue);

      .item-link {
        background: var(--his-slate-blue);
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
